import './styles.scss';
import React, { useState } from 'react';
import { UncontrolledTooltip, Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { GeckoAvatar, GeckoIcon } from '@geckolabs/gecko-react-ui';
import { HOST_HIGHLIGHTED_EVENT } from '../../constants';
import { AdminService } from '../../services/AdminService';
import { PresenceSocketService } from '../../services/PresenceSocketService';
import { VideoService } from '../../services/VideoService';
import { __, STR_KEY } from '../../../../services/Translate';

const Hosts = ({ hosts }) => {
    if (!hosts || hosts.length < 1) return null;

    const prepareHostsFn = (host) => {
        // Prepare host name
        host.name = `${host.first_name} ${host.last_name}`;
        return host;
    };

    return (
        <>
            <h2 className="hosts-heading branded-text">{__(STR_KEY.VIDEO_DESCRIPTION_TITLE_HOSTS)}</h2>
            <div className="hosts-container">
                <RenderHosts hosts={hosts.map(prepareHostsFn)} />
            </div>
        </>
    );
}

export const AvatarGroup = ({ host, index }) => {
    return (
        <div className="host-avatar">
            <AdminControl host={host}>
                <div id={`HostAvatar-${index}`}>
                    <GeckoAvatar
                        name={host.name}
                        bgImage={host.avatar} />
                    <UncontrolledTooltip delay={0} placement="top" target={`HostAvatar-${index}`}>
                        {host.name}
                    </UncontrolledTooltip>
                </div>
            </AdminControl>
        </div>
    );
}

export const HostItem = ({ host }) => {
    return (
        <AdminControl host={host}>
            <div className="host-info">
               
                    <div>
                        <GeckoAvatar
                            name={host.name}
                            bgImage={host.avatar} />
                    </div>
                    <div>
                        <p className="host-name">{host.name}</p>
                        {host.position ? <p className="host-position">{host.position}</p> : null}
                    </div>
                
            </div>
        </AdminControl>
    );
}

export const RenderHosts = ({ hosts }) => {
    if (hosts.length > 2) {
        return (
            <div className="hosts-avatar-group">
                {hosts.map((host, index) => {
                    return <AvatarGroup host={host} index={index} key={index} />
                })}
            </div>
        );
    } else {
        return (
            hosts.map((host, index) => {
                return <HostItem key={index} host={host} />
            })
        );
    }
}

const AdminControl = ({children, host}) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen(prevState => !prevState);

    // Dont render controls when NOT admin user
    if (!AdminService.isAdmin()) return children;

    const highlightHostFn = () => {
        PresenceSocketService.trigger(HOST_HIGHLIGHTED_EVENT, {
            name: host.name, 
            position: host.position,
            fragmentId: VideoService.currentFragmentId()
        });
        // Close dropdown
        toggle();
    };

    return (
        <Dropdown className="gecko-ui-dropdown" isOpen={dropdownOpen} toggle={toggle} direction="down">
            <DropdownToggle
                tag="div"
                className="host-dropdown-toggle"
                data-toggle="dropdown"
                aria-expanded={dropdownOpen}>
                {children}
            </DropdownToggle>
            <DropdownMenu tag="ul" className={'rounded dropdown-menu-left'} flip={false}>
                <li className="dropdown-item" onClick={highlightHostFn}>
                    <GeckoIcon icon="star" />
                    &nbsp;
                    {__(STR_KEY.VIDEO_ADMIN_CONTROL_HIGHLIGHT_HOST)}
                </li>
            </DropdownMenu>
        </Dropdown>
    );
}

export default Hosts;